import { useState } from "react";
import { Menu, X } from "lucide-react";
import { LINKS, NAV_ITEMS } from "./links";

const Nav = () => {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-nav"
      className="nav-bg sticky top-0 z-50 border-b border-[var(--line)]"
    >
      <div className="container-x flex items-center justify-between px-6 py-4">
        <a href="#top" data-testid="nav-brand" className="font-display text-xl tracking-tight">
          Intuitive Shoes
        </a>

        <nav aria-label="Primary" className="hidden items-center gap-8 lg:flex">
          {NAV_ITEMS.map((item) => (
            <a
              key={item.href}
              href={item.href}
              data-testid={`nav-link-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-sm text-[var(--ink-soft)] transition-colors duration-200 hover:text-[var(--ink)]"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={LINKS.APP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-try-app-btn"
            className="btn-primary hidden !py-2.5 !px-5 sm:inline-flex"
          >
            Try the App
          </a>
          <button
            type="button"
            aria-label={open ? "Close menu" : "Open menu"}
            aria-expanded={open}
            data-testid="nav-menu-toggle"
            onClick={() => setOpen(!open)}
            className="rounded-full border border-[var(--line)] p-2 lg:hidden"
          >
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>

      {open && (
        <nav
          aria-label="Mobile"
          data-testid="nav-mobile-menu"
          className="border-t border-[var(--line)] bg-[var(--cream)] px-6 py-4 lg:hidden"
        >
          <ul className="flex flex-col gap-4">
            {NAV_ITEMS.map((item) => (
              <li key={item.href}>
                <a
                  href={item.href}
                  data-testid={`nav-mobile-link-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                  onClick={() => setOpen(false)}
                  className="text-base text-[var(--ink-soft)]"
                >
                  {item.label}
                </a>
              </li>
            ))}
            <li>
              <a
                href={LINKS.APP_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="nav-mobile-try-app-btn"
                className="btn-primary mt-2"
              >
                Try the App
              </a>
            </li>
          </ul>
        </nav>
      )}
    </header>
  );
};

export default Nav;
